import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import useConfigureGoogleMaps, { GoogleMapsContext } from '.';

export default function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useConfigureGoogleMaps();

  const value = useMemo(() => ({ isLoaded, loadError }), [isLoaded, loadError]);

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

GoogleMapsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
